export const finance = {
  section: {
    title: 'Finance',
  },
  annualCosts: {
    title: 'Annual company costs',
    description:
      'Recurring costs funded from the company kitty. Enter annual or monthly amounts — monthly figures are multiplied by 12. These are deducted before paid work hours are calculated and are not added to the hours pool.',
    total: 'Annual total {{value}}',
    empty: 'No company costs yet.',
    label: 'Cost name',
    amount: 'Amount £',
    amountAnnual: 'Annual £',
    amountMonthly: 'Monthly £',
    period: 'Period',
    periodAnnual: 'Annual',
    periodMonthly: 'Monthly',
    note: 'Note (optional)',
    add: 'Add cost',
    clear: 'Clear all',
    remove: 'Remove cost',
    perYear: '/yr',
    perMonth: '/mo',
    annualised: '{{monthly}}/mo → {{annual}}/yr',
    statLabel: 'Annual total',
    menuDescription: 'Recurring costs taken from the company kitty',
  },
  oneOffCosts: {
    title: 'One-off company costs',
    description:
      'Single costs for financial year {{financialYear}} (April–March). These reduce paid work hours for that year only, the same way as recurring costs.',
    totalCurrentFy: '{{financialYear}} total {{value}}',
    empty: 'No one-off costs yet.',
    label: 'Cost name',
    amount: 'Amount £',
    note: 'Note (optional)',
    add: 'Add for {{financialYear}}',
    clear: 'Clear all',
    remove: 'Remove cost',
    fyChip: 'FY {{financialYear}}',
    notCurrentFy: 'Past year — not deducted now',
  },
  combinedDeduction: {
    statLabel: 'Kitty deduction this FY',
    statHint: 'Recurring annual total plus one-offs for the current financial year',
  },
  success: {
    annualCostsUpdated: 'Annual company costs updated',
    oneOffCostsUpdated: 'One-off company costs updated',
  },
};
